import { RouterProvider } from "react-router";
import { ThemeProvider } from "next-themes";
import { ToastContainer } from "./components/ui/Toast";
import { useToastStore } from "../stores/toastStore";
import { router } from "./routes";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { DiscoveryProgressBanner } from "./components/ui/DiscoveryProgressBanner";

function ToastListener() {
  const currentToast = useToastStore((state) => state.currentToast);
  const removeToast = useToastStore((state) => state.removeToast);

  return <ToastContainer currentToast={currentToast} onClose={removeToast} />;
}

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider attribute="class" defaultTheme="dark" disableTransitionOnChange>
        <RouterProvider router={router} />
        <ToastListener />
        <DiscoveryProgressBanner />
      </ThemeProvider>
    </ErrorBoundary>
  );
}
